import { ArrowRight } from "lucide-react";
import { CAPABILITIES, IMAGES } from "../../data/content";

export const Hero = () => (
  <section id="top" className="relative min-h-screen flex flex-col bg-[#0A0A0A]" data-testid="hero-section">
    <div className="absolute inset-0 overflow-hidden">
      <img
        src={IMAGES.hero}
        alt="Earth at night from space"
        className="w-full h-full object-cover opacity-70"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-[#0A0A0A] via-[#0A0A0A]/60 to-transparent" />
      <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A] via-transparent to-[#0A0A0A]/40" />
    </div>

    <div className="hidden xl:flex absolute right-10 top-1/3 flex-col gap-6 font-mono text-[10px] tracking-[0.4em] text-white/40 [writing-mode:vertical-rl]">
      <span>PEOPLE</span>
      <span>INSTITUTIONS</span>
      <span>PROGRESS</span>
    </div>

    <div className="relative flex-1 flex flex-col justify-center px-6 lg:px-12 pt-32 pb-16 max-w-5xl">
      <h1
        data-testid="hero-headline"
        className="font-display text-5xl sm:text-6xl lg:text-[5.5rem] leading-[1.05] tracking-tight text-white"
      >
        Engineering
        <br />
        the Intelligence Age.
      </h1>
      <p className="mt-8 max-w-xl text-base sm:text-lg leading-relaxed text-white/70" data-testid="hero-subcopy">
        Building intelligent systems, digital infrastructure and institutional
        capabilities for governments and critical environments.
      </p>
      <div className="mt-10">
        <a
          href="#capabilities"
          data-testid="hero-explore-btn"
          className="inline-flex items-center gap-3 font-mono text-xs tracking-[0.3em] text-white border-b border-white/40 pb-3 hover:border-white hover:gap-5 transition-all duration-300"
        >
          EXPLORE OUR CAPABILITIES <ArrowRight className="w-4 h-4" />
        </a>
      </div>
    </div>

    <div className="relative border-t border-white/15" data-testid="hero-capability-tabs">
      <div className="grid grid-cols-2 lg:grid-cols-4">
        {CAPABILITIES.map((c, i) => (
          <a
            key={c.n}
            href="#capabilities"
            data-testid={`hero-tab-${c.n}`}
            className={`group flex items-start gap-4 px-6 lg:px-8 py-6 border-white/15 ${
              i > 0 ? "border-l max-lg:[&:nth-child(3)]:border-l-0 max-lg:[&:nth-child(n+3)]:border-t" : ""
            } hover:bg-white/5 transition-colors duration-300`}
          >
            <span className="font-mono text-[10px] tracking-[0.2em] text-white/40 pt-1">{c.n}</span>
            <span className="font-mono text-[11px] tracking-[0.25em] text-white/80 uppercase leading-relaxed group-hover:text-white transition-colors duration-300">
              {c.title}
            </span>
          </a>
        ))}
      </div>
      <p className="px-6 lg:px-12 pb-6 font-mono text-[10px] tracking-[0.3em] text-white/40">
        INDIA · UNITED STATES · MIDDLE EAST · ASIA PACIFIC
      </p>
    </div>
  </section>
);
